import { Clock, Calendar } from "lucide-react";
import { Badge, TableCell } from "@pushpress/pushpress-ui";
import { convertIsoDateOrTimestampToUSDateAndTimeFormat } from "../../../helpers";

export const renderStatus = (row) => {
  const { status } = row;
  switch (status) {
    case "opened":
      return (
        <Badge size="sm" variant="success">
          Read
        </Badge>
      );
    case "delivered":
      return (
        <Badge size="sm" variant="info">
          Delivered
        </Badge>
      );
    case "sent":
      return (
        <Badge size="sm" variant="outline">
          Sent
        </Badge>
      );
  }
  return (
    <Badge size="sm" variant="secondary">
      Created
    </Badge>
  );
};

export const renderChannel = (row) => {
  const messageType = row.getValue();
  if (messageType.toUpperCase() === "EMAIL") {
    return <Badge size="sm">Email</Badge>;
  }
  return (
    <Badge size="sm" variant="success">
      SMS
    </Badge>
  );
};

export const renderDateTime = (row) => {
  const { timestamp } = row;
  const { date, time } =
    convertIsoDateOrTimestampToUSDateAndTimeFormat(timestamp);
  return (
    <TableCell key={row.id}>
      <div className="tw-flex tw-items-center">
        <Calendar className="tw-h-3 tw-w-3 tw-mr-1" />
        {date}
      </div>
      <div className="tw-flex tw-items-center tw-text-sm tw-text-neutral-600">
        <Clock className="tw-h-3 tw-w-3 tw-mr-1" /> {time}
      </div>
    </TableCell>
  );
};
export const columns = [
  {
    header: "Date & Time",
    accessorKey: "timestamp",
    cell: ({ row: { original } }) => renderDateTime(original),
  },
  {
    header: "Channel",
    accessorKey: "messageType",
    cell: (row) => renderChannel(row),
  },
  {
    header: "Subject",
    accessorKey: "subject",
  },
  {
    header: "Status",
    cell: ({ row: { original } }) => renderStatus(original),
  },
];
